var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
export class DocumentRetrievalTechnicalErrorViewModel {
    constructor(parentModel) {
        this.parentModel = parentModel;
    }
    get canAddLocations() {
        return this.parentModel.canAddLocations;
    }
    get fastenPublicId() {
        return this.parentModel.fastenPublicId;
    }
    get fastenPatientId() {
        return this.parentModel.fastenPatientId;
    }
    get isStatic() {
        return this.parentModel.uiState.isStatic;
    }
    get title() {
        if (this.isClearError) {
            return this.parentModel.getAuthErrorText;
        }
        return t("We couldn’t find your records");
    }
    get supportingText() {
        if (this.isClearError) {
            return t("Please try again to continue.");
        }
        if (this.canAddLocations) {
            return t("Something went wrong while finding your records. You can try again or manually add your providers to continue.");
        }
        return t("Something went wrong while finding your records. You can try again or continue without sharing records.");
    }
    async handleTryAgain() {
        await this.parentModel.retryTEFCARetrieval();
    }
    async addProvidersMyself() {
        await this.parentModel.addProvidersFromTechnicalError();
    }
    async handleContinueWithoutSharing() {
        await this.parentModel.confirmContinueWithoutSharing();
    }
    async reauth() {
        await this.parentModel.reauth();
    }
    get isClearError() {
        return !!this.parentModel.needsToReauthWithCLEAR;
    }
    get isTEFCAError() {
        return this.parentModel.isTEFCAError;
    }
}
__decorate([
    computed
], DocumentRetrievalTechnicalErrorViewModel.prototype, "title", null);
__decorate([
    computed
], DocumentRetrievalTechnicalErrorViewModel.prototype, "supportingText", null);
__decorate([
    computed
], DocumentRetrievalTechnicalErrorViewModel.prototype, "isClearError", null);
__decorate([
    computed
], DocumentRetrievalTechnicalErrorViewModel.prototype, "isTEFCAError", null);
